import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useIntegrations } from "@/features/integrations/hooks/useIntegrations";
import { ModuleName } from "@/features/integrations/utils/module-name";
import { decodeSlug, encodeSlug } from "@/features/integrations/utils/slug";
import { useAuth } from "@/lib/hooks/useAuth";
import { useBreadcrumbs } from "@/lib/hooks/useBreadcrumbs";

export function useJobSourceClientDetailsBreadcrumbs() {
  const { t, i18n } = useTranslation();
  const { integrationName, clientId } = useParams<{
    integrationName: string;
    clientId: string;
  }>();
  const { tenantId } = useAuth();

  const integrationsQuery = useIntegrations({ tenantId, clientId });
  const decodedIntegrationName = integrationName
    ? decodeSlug(integrationName)
    : null;
  const integration = integrationsQuery.data?.find(
    (i) => i.name === decodedIntegrationName
  );

  const integrationDisplayName =
    integration?.displayName && i18n.exists(integration.displayName)
      ? t(integration.displayName)
      : integration?.displayName || decodedIntegrationName || "";

  const breadcrumbs = useBreadcrumbs({
    items: [
      {
        label: t("common.integrations"),
        href: `/${ROUTES.clients}/${clientId}/${ROUTES.integrations}`,
      },
      {
        label: integrationDisplayName,
        href: `/${ROUTES.clients}/${clientId}/${ROUTES.integrations}/${encodeSlug(
          decodedIntegrationName || ""
        )}`,
      },
      {
        label: t(`integrations.modules.names.${ModuleName.JobSource}`),
      },
    ],
  });

  return { breadcrumbs };
}
